import { render } from "./WarningMessageBar.vue?vue&type=template&id=6273f58a&scoped=true&ts=true"
import script from "./WarningMessageBar.vue?vue&type=script&lang=ts"
export * from "./WarningMessageBar.vue?vue&type=script&lang=ts"

import "./WarningMessageBar.vue?vue&type=style&index=0&id=6273f58a&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6273f58a"]])

export default __exports__